// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3YVr6","footer":"ReportModalFilter_footer__2uHIu"};